import { render, staticRenderFns } from "./tabnav.vue?vue&type=template&id=74f89381&scoped=true"
import script from "./tabnav.vue?vue&type=script&lang=js"
export * from "./tabnav.vue?vue&type=script&lang=js"
import style0 from "./tabnav.vue?vue&type=style&index=0&id=74f89381&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f89381",
  null
  
)

export default component.exports